import styled from '@emotion/styled/macro';
import React, { useEffect, useRef, useState } from 'react';
import { useRefinementList } from 'react-instantsearch';
import { AngleDownIconAtom } from '../../atoms/icon-atoms/icon-atoms';
import Translate from '../../utils/translation-functions';
import vars from '../../variables';

// TODO depending on final design map colours of each topic or if in CMS pull in topic colour

const TopicsFilter = props => {
  const { items, refine } = useRefinementList(props);
  const label = props.label;

  const [isOpen, setIsOpen] = useState(false);

  const listStyle = {
    zIndex: isOpen ? '100' : '0',
  };
  const selectWrapper = useRef();

  const handleOutsideClick = e => {
    if (selectWrapper.current.contains(e.target)) {
      return;
    }
    setIsOpen(false);
  };

  const isEmpty = items.length <= 0;

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [isOpen]);

  const handleClick = () => setIsOpen(!isOpen);

  const itemsToDisplay = () => {
    if (isOpen === false) return [];
    else return items;
  };

  return (
    <div className="ais-RefinementList" ref={selectWrapper}>
      <ul
        className={`ais-RefinementList-list ${isEmpty ? 'empty' : ''}`}
        style={listStyle}
      >
        <button
          className="ais-RefinementList-showMore"
          data-testid="filter-dropdown"
          disabled={isEmpty}
          onClick={handleClick}
        >
          <li key="filterby" className="ais-RefinementList-item-showMore">
            <span>{Translate(label, true)}</span>
            <AngleDownIconAtom width="1.5rem" fillOpacity={isEmpty ? 0.1 : 1} />
          </li>
        </button>
        {itemsToDisplay().map((item, index) => {
          if (item.label !== 'Other/None applicable') {
            return (
              <li
                key={`${item.label.slice(0, 3)}-${index}`}
                className="ais-RefinementList-item"
              >
                <label className="ais-RefinementList-label">
                  <input
                    className="ais-RefinementList-checkbox"
                    data-testid={
                      `${item.value}`
                        ? `${item.value.toString().toLowerCase()}-checkbox`
                        : `checkbox`
                    }
                    type="checkbox"
                    value={item.value}
                    checked={item.isRefined ? true : false}
                    onChange={event => {
                      refine(item.value);
                    }}
                  />
                  <span className="ais-RefinementList-labelText">
                    {Translate(item.label, true)}
                  </span>
                </label>
              </li>
            );
          } else return null;
        })}
      </ul>
    </div>
  );
};
const StyledTopicsFilter = styled(TopicsFilter)`
  display: inline-block;
  ul {
    list-style: none;
  }
  li {
    ${vars.fontSize2}
    color: ${vars.coreDarkGrey};
  }
`;

export default StyledTopicsFilter;
